import { Component, EventEmitter, Input, Output, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import { DatePipe } from '@angular/common';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';//CDPJ
import { isNullOrUndefined } from 'util';
import { UtilitariosService } from '../../advantage/advantageservices/utilitarios.service';
import { InvTrndismp } from "../invinterfaces/invtrndismp";
import { TrnpordismpService } from "../invservicios/trnpordismp.service";
import { InventradaprodService } from "../invservicios/inventradaprod.service";
@Component({
  selector: 'app-trnpordismp',
  templateUrl: './trnpordismp.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class TrnpordismpComponent implements OnInit, OnChanges {
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;

  @Input() kar_nro: string
  @Input() ordpro: string;
  @Input() detalle
  @Output() salir = new EventEmitter<boolean>();

  botonNuevo: boolean;
  botonGuardar: boolean;
  botonBorrar: boolean;
  botonRegresar: boolean;
  oculto: boolean;

  largo: string;

  distrimpSelected: InvTrndismp

  public frameworkComponents;
  rowStyle;
  desCodigo: boolean;
  defaultColDefDistri;
  rowSelection = 'multiple';

  lineaEntrada: number;
  decimalesTotalEnt:number;
  columnDefsDistri = [
    {//0
      headerName: 'Nro', field: 'KAR_NRO', cellEditor: 'cellPrueba',width: 110,
      editable: (params) => {
        return false;
      },
    },
    {//1
      headerName: 'Art. Código', field: 'ART_CODIGO',width: 160, cellEditor: 'cellPrueba',
      editable: (params) => {
        return false;
      },
    },
    {//2
      headerName: 'Nombre', field: 'ART_NOMBRE', width: 290, cellEditor: 'cellPrueba',
      editable: (params) => {
        return false;
      },
    },
      {//3
        headerName: 'Cantidad', field: 'DETKAR_CANTIDAD', cellEditor: 'cellPrueba',cellStyle: { textAlign: 'right' },
        editable: (params) => {
          return false;
        },
        cellEditorParams:
        {
          values: {
            mayusculas: false,
            numeros: true,
            alphabetic: true,
            saltoslinea: 1,
            newrow: false,
            numerodecimales: 2,
            obligatorio: true,
            fecha: false,
            tamanocelda: 32
          }
        }
      },
    {//3
      headerName: 'Costo', field: 'DETKAR_COSTOUNIT', cellEditor: 'cellPrueba',cellStyle: { textAlign: 'right' },
      editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: true,
          fecha: false,
          tamanocelda: 32
        }
      }
    },
,
    {//5
      headerName: 'Total', field: 'DETKAR_COSTOTOTAL', cellEditor: 'cellPrueba',cellStyle: { textAlign: 'right' },
      // , editable: true,
      editable: (params) => {
        return false;
      },

    },
  ];

  constructor(
    public trnpordismpService: TrnpordismpService,
    private datePipe: DatePipe,
    private messageService: MessageService, private auditoriagral: AuditoriagralService,
    private confirmationService: ConfirmationService, private init: NuevoComponentService,
    private confIniciales: ConfInicialesService,
    private utilitariosService: UtilitariosService, public inventradaprodService:InventradaprodService
  ) {
    this.agTable();

  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };

    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };
    this.defaultColDefDistri = {
      editable: true,
      width: 100,
      objeto: 'distrimp'
    };
  }
  ngOnInit() {
    this.botonNuevo = true;
    this.botonGuardar = true;
    this.botonBorrar = true;
    this.botonRegresar = true;
    this.oculto = true;

    this.largo = '500';
    this.decimalesTotalEnt=2;
    this.distrimpSelected = {}
    this.trnpordismpService.distribucionmp = []
  }
  ngOnChanges(changes: SimpleChanges) {
    for (const e in changes) {
      if (e === 'kar_nro' &&  isNullOrUndefined(this.kar_nro) === false && isNullOrUndefined(this.ordpro) === false) {
        //this.lineaEntrada = this.detalle.DETKAR_LINEA
        this.confIniciales.getDecimales('frmINV_ENCKARDEX').subscribe((dec) => {
          if (dec !== null) {
            dec.map((decimales) => {
                if (decimales.NUMDEC_CAMPO === 'COSTOTOTAL') {
                this.decimalesTotalEnt = Number(decimales.NUMDEC_NUMDEC);
                this.trnpordismpService.decimalesTotalEnt = this.decimalesTotalEnt;
              }
            });
            this.columnDefsDistri[3].cellEditorParams = {
              values: {
                mayusculas: false,
                numeros: true,
                alphabetic: false,
                saltoslinea: 1,
                newrow: false,
                numerodecimales: this.trnpordismpService.decimalesTotalEnt,
                obligatorio: false,
                fecha: false,
                tamanocelda: 32
              }
            };
            this.aggrid.refreshColumnDefs();
          }
        });
        this.mostrardetalle()
      }
    }

  }

  manejarSenales(valor) {
    if (valor === 'Salir') {
      this.salir.emit(true);
    }
    if (valor === 'Cancelar') {
      this.mostrardetalle()
    }
  }
  seleccionDistri(params) {

  }
  cambio(evento) {

  }
  async mostrardetalle(){
    try {
      const rs = await this.trnpordismpService.getdetdistribucion(this.ordpro);
      if (rs!==null && rs.length>0) {
        for (const iterator of rs) {
          iterator.DETKAR_CANTIDAD=Number(iterator.DETKAR_CANTIDAD).toFixed(this.inventradaprodService.decimalesCantidadEnt)
          iterator.DETKAR_COSTOUNIT=Number(iterator.DETKAR_COSTOUNIT).toFixed(this.inventradaprodService.decimalesPrecioEnt)
          iterator.DETKAR_COSTOTOTAL=Number(iterator.DETKAR_COSTOTOTAL).toFixed(this.inventradaprodService.decimalesTotalEnt)

        }
        this.trnpordismpService.distribucionmp=rs
      }

    } catch (error) {
      this.messageService.add({
        key: 'comdistridistrimpccUsuToken',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al consultar la distribución'
      });
      console.log(error)
    }
  }
}
